"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.videoLayoutClasses = void 0;
var _mui = require("@ori-ui/mui");
const videoLayoutClasses = exports.videoLayoutClasses = (0, _mui.generateUtilityClasses)('VideoLayout', [
    'root',
    'externalRoot',
    'video',
    'iframe'
]);
